import { format, parseISO, differenceInCalendarDays } from "date-fns";
import { ro } from "date-fns/locale";

export const NONE = "__none";

export const ITEM_STATUSES = [
  { key: "de_facut", label: "Planificat", text: "text-zinc-100", dot: "bg-zinc-400", pill: "border-zinc-600 text-zinc-200 bg-zinc-800/70" },
  { key: "brut", label: "Brut", text: "text-emerald-400", dot: "bg-emerald-400", pill: "border-emerald-700 text-emerald-300 bg-emerald-950/60" },
  { key: "postat", label: "Postat", text: "text-emerald-700 line-through", dot: "bg-emerald-700", pill: "border-emerald-900 text-emerald-600 bg-emerald-950/30" },
  { key: "hold", label: "Pe hold", text: "text-violet-300", dot: "bg-violet-400", pill: "border-violet-800 text-violet-300 bg-violet-950/50" },
];
export const ITEM_STATUS_MAP = Object.fromEntries(ITEM_STATUSES.map((s) => [s.key, s]));
export const editorIds = (s) => (s.editor_ids?.length ? s.editor_ids : s.editor_id ? [s.editor_id] : []);
export const editorNames = (s, teamById) => editorIds(s).map((i) => teamById[i]?.name).filter(Boolean);

export const DEPARTMENTS = [
  { key: "editare", label: "Editori" },
  { key: "filmare", label: "Filmare" },
  { key: "coordonare", label: "Coordonare" },
];
export const DEPT_MAP = Object.fromEntries(DEPARTMENTS.map((d) => [d.key, d]));

export const CLIENT_COLORS = ["#F59E0B", "#22C55E", "#3B82F6", "#8B5CF6", "#EC4899", "#06B6D4", "#EF4444", "#A3E635"];

export const todayISO = () => format(new Date(), "yyyy-MM-dd");

export function fmtDate(d, pattern = "d MMM yyyy") {
  if (!d) return "—";
  try {
    return format(parseISO(d), pattern, { locale: ro });
  } catch {
    return d;
  }
}

export function daysLeft(d) {
  if (!d) return null;
  return differenceInCalendarDays(parseISO(d), new Date());
}

export function timeAgo(iso) {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "acum";
  if (diff < 3600) return `acum ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `acum ${Math.floor(diff / 3600)} h`;
  return fmtDate(iso.slice(0, 10), "d MMM");
}

export const lastName = (n) => (n || "").trim().split(/\s+/).pop();

export const stripClient = (title, clientName) =>
  clientName ? title.replace(new RegExp(`^${clientName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*[-–:]\\s*`, "i"), "") : title;

export function itemLine(item, teamById, clientName) {
  const editor = editorNames(item, teamById).join(", ");
  const title = stripClient(item.title, clientName);
  return [title, item.post_time && `ora ${item.post_time}`, editor && editor.toUpperCase()].filter(Boolean).join(" - ");
}

export function waLink(text, phone) {
  const p = (phone || "").replace(/[^\d]/g, "");
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
}

